import {
  STATUS_AVISO_LABEL,
  StatusAviso,
} from '../../../types/aviso';

export const formatDateTime = (iso: string | null): string => {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(iso));
  } catch {
    return iso;
  }
};

export const formatDate = (iso: string | null): string => {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(new Date(iso));
  } catch {
    return iso;
  }
};

export const statusLabel = (status: StatusAviso | null | undefined): string => {
  if (!status) return '—';
  return STATUS_AVISO_LABEL[status] ?? status;
};

export const toDateInputValue = (iso: string | null | undefined): string => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const toIsoFromDateInput = (value: string): string => {
  if (!value) return '';
  const [y, m, d] = value.split('-').map((s) => parseInt(s, 10));
  const date = new Date(Date.UTC(y, (m ?? 1) - 1, d ?? 1, 0, 0, 0));
  return date.toISOString();
};
